<template>
  <Drawer
    :id="drawerId"
    :title="title"
    titleIcon="mdi-file-document"
    preloadContent
    bottom
    height="75%"
    padded
    closeGoesBack
    hideBack
    :customBackFunc="customBackFunc()"
    :loading="loading"
  >
    <div>
      <CertificateManagementView
        v-show="showManagementView"
        :userId="userId"
        @goDetails="goDetails"
      />
      <CertificateDetailsView
        v-if="showDetailsView"
        :id="selectedCertificateId"
        :userId="userId"
        @home="goHome"
      />
    </div>
  </Drawer>
</template>

<script>
import Drawer from '@/components/layout/Drawer';
import { DRAWERS } from '@/utils/constants';
import { mapGetters } from 'vuex';
import { EXEMPTION_CERTIFICATE_VIEWS } from '../../../utils/constants';
import CertificateDetailsView from './CertificateDetailsView';
import CertificateManagementView from './CertificateManagementView';

export default {
  name: 'ExemptionCertificatesDrawer',

  components: {
    Drawer,
    CertificateManagementView,
    CertificateDetailsView
  },

  data() {
    return {
      drawerId: DRAWERS.EXEMPTION_CERTIFICATES_DRAWER,
      activeView: EXEMPTION_CERTIFICATE_VIEWS.MANAGEMENT,
      selectedCertificateId: 0,
      loading: false,
      userId: null
    };
  },

  computed: {
    title() {
      if (this.activeView === EXEMPTION_CERTIFICATE_VIEWS.MANAGEMENT) {
        return 'Tax Exempt Certificates';
      } else return 'Certificate Details';
    },

    showManagementView() {
      return this.activeView === EXEMPTION_CERTIFICATE_VIEWS.MANAGEMENT;
    },

    showDetailsView() {
      return this.activeView === EXEMPTION_CERTIFICATE_VIEWS.DETAILS;
    },

    ...mapGetters({
      initialData: 'drawers/data',
      drawerOpenedAt: 'drawers/lastOpenedAt'
    })
  },

  watch: {
    drawerOpenedAt() {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        this.activeView = EXEMPTION_CERTIFICATE_VIEWS.MANAGEMENT;
        const initial = this.initialData(this.drawerId) || {};
        this.userId = initial.userId || null;
        this.loading = true;
        this.$store.dispatch('user/refreshProfile').finally(() => {
          this.loading = false;
        });
      }
    }
  },

  methods: {
    goHome() {
      this.activeView = EXEMPTION_CERTIFICATE_VIEWS.MANAGEMENT;
    },

    goDetails(id) {
      this.activeView = EXEMPTION_CERTIFICATE_VIEWS.DETAILS;
      this.selectedCertificateId = id;
    },

    customBackFunc() {
      if (this.showDetailsView) {
        return () => {
          this.activeView = EXEMPTION_CERTIFICATE_VIEWS.MANAGEMENT;
        };
      } else {
        return null;
      }
    }
  }
};
</script>

<style scoped></style>
